import { MedicalCode, MedicalCodeControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface useAddCataLogCodeParam {
  values: MedicalCode;
  xTENANTID?: string;
}

/**
 * @author rajkumar rathod
 */
export const useAddCataLogCode = () =>
  useMutationWithLoading(async (params: useAddCataLogCodeParam) =>
    new MedicalCodeControllerApi(getConfigObject()).createMedicalCode(
      params.values,
      params.xTENANTID
    )
  );
